/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

import { createApp } from 'vue'

import App from './App.vue'
import { registerPlugins } from '@/core/plugins'
import pinia from '@/core/plugins/store'
import i18n from '@/i18n'
import { getLang } from '@/i18n/helpers'
import { useAuthStore } from '@/features/auth/store/auth'

const app = createApp(App)

// Register plugins first
registerPlugins(app)

app.use(pinia)
app.use(i18n)

const authStore = useAuthStore()

// Check if we're already on a public auth page
const currentPath = window.location.pathname
const isAuthPage = /^\/((en|fr)\/(login|register|recovery|verification|errors)|auth(\/(login|register|recovery|verification|errors))?)$/.test(currentPath)

// Wait for auth to be verified BEFORE mounting the app
authStore.fetchUser().then(() => {
  if (!authStore.user && !isAuthPage) {
    // redirect to login page only if we're not already on an auth page
    const locale = getLang(navigator.language)
    window.location.href = `/${locale}/login`
  } else {
    // Mount the app if user is authenticated OR if we're on an auth page
    app.mount('#app')
  }
})
